import React from 'react'
import styled from 'styled-components'
import { useLogic } from '~common/ui-logic/hooks/logic'
import { useAppContext } from '~/app-context'
import { ErrorBoxLogic, type ErrorBoxLogicDependencies } from './logic'

export interface ErrorBoxProps extends ErrorBoxLogicDependencies {}

export function ErrorBox(props: ErrorBoxProps) {
    const appContext = useAppContext()
    const { state } = useLogic(ErrorBoxLogic, {
        ...props,
        ...appContext,
    })

    if (!state.message) {
        return null
    }

    return <Container>{state.message}</Container>
}

const Container = styled.div`
    background-color: ${({ theme }) => theme.colors.error[50]};
    border: 1px solid ${({ theme }) => theme.colors.error[200]};
    color: ${({ theme }) => theme.colors.error};
    padding: 12px;
    border-radius: 4px;
    margin: 8px 0;
`
